import React from 'react';
import Col from 'react-bootstrap/Col';
import Dropdown from 'react-bootstrap/Dropdown';
import { SearchParamNames } from '../../models/enums';
import { SortByValues } from '../../models/globals';
import { SearchAction } from '../../hooks/search/reducers/SearchActions';

interface SearchSortByProps {
    dispatch: React.Dispatch<SearchAction>;
    sortInUse: SortByValues;
}

const SortDisplayValueMap: Record<SortByValues, string> = {
    relevance: 'Relevance',
    name: 'Alphabetical A-Z',
};

const SearchSortBy: React.FC<SearchSortByProps> = ({ dispatch, sortInUse }) => {
    const [selection, setSelection] = React.useState(sortInUse);

    return (
        <Col className="my-3 search-sort-text text-right">
            <Dropdown
                onSelect={(value) => {
                    dispatch({ type: SearchParamNames.Sort, payload: value as SortByValues });
                }}
                className="mt-3"
                data-testid="sort-by-dropdown"
            >
                <span className="align-middle">Sort By:</span>
                <Dropdown.Toggle
                    aria-label="Sort By"
                    variant="primary"
                    className="bg-transparent search-sort-text border-0"
                >
                    {SortDisplayValueMap[sortInUse]}
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-sort-menu">
                    <Dropdown.Item
                        active={selection === 'relevance'}
                        eventKey="relevance"
                        className="dropdown-sort-item"
                        onBlur={() => setSelection(sortInUse)}
                        onFocus={() => setSelection('relevance')}
                    >
                        {SortDisplayValueMap.relevance}
                    </Dropdown.Item>
                    <Dropdown.Item
                        active={selection === 'name'}
                        eventKey="name"
                        className="dropdown-sort-item"
                        onBlur={() => setSelection(sortInUse)}
                        onFocus={() => setSelection('name')}
                    >
                        {SortDisplayValueMap.name}
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </Col>
    );
};

export { SearchSortByProps, SearchSortBy };
